export class Utils {
    public static formatNumber = (text?: number) => {
        if (text === undefined || text === null) return undefined;
        return text?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
}